import {html} from "lit-element";
import {StofwarePageCrud} from "@stofloos/core/base/sw-page-crud";
import "@stofloos/components/organisms/tables/table-dynamic";
import {localize} from "@stofloos/actions/localize";
import {store} from "@stofloos/stores/store";
import {incrementPage, initRequest, setPageLimit, setQueryFilter} from "@stofloos/actions/requests";
import {LayoutFlex} from "@stofloos/globals/styles/layout-flex";
import "@stofloos/components/molecules/dialogs/dialog-simple";
import "@stofloos/components/atoms/buttons/button-contained";
import {textToSlug} from "@stofloos/utils/sw-constants";
import "@stofloos/components/atoms/icons/sw-icon";

import {style} from "./style";
import groupBy from "lodash-es/groupBy";
import moment from "moment";
import 'moment/src/locale/nl';

import {readObjects} from "@stofloos/actions/crud";

class PageEvents extends StofwarePageCrud {
    static get styles() {
        return [
            LayoutFlex,
            style
        ]
    }

    static get properties() {
        return {
            label: String,
            banner: String,
            announcedEvents: {type: Array}
        }
    }

    constructor() {
        super();

        this.addEventListener('sw-table:read-object', this.showObject);
        this.objects = [];
        this.orderBy = "start_date";
        this.orderDirection = "asc";
        const today = moment();
        this.filters = [{name: "start_date", operator:"ge", value: today}];
    }

    firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        store.dispatch(initRequest(this.requestId+"NoStartDate", this.endpoint));
        store.dispatch(setPageLimit(this.requestId+"NoStartDate", this.pageLimit));
        store.dispatch(setQueryFilter(this.requestId+"NoStartDate", "deleted", "eq", false));
        store.dispatch(setQueryFilter(this.requestId+"NoStartDate", "start_date", "eq", null));
        store.dispatch(readObjects(this.requestId+"NoStartDate"));
    }

    stateChanged(state) {
        super.stateChanged(state);
        if (state.crud[this.requestId+"NoStartDate"] && (state.app.page === this.endpoint || this.pageName === this.endpoint)) {
            this.announcedEvents = state.crud[this.requestId+"NoStartDate"];
        }
    }

    render() {
        if(!this.objects) {
            return html``;
        }
        const grouped = groupBy(this.objects, function(item) {
            return moment(item.start_date).format('MMMM YYYY');
        });
        const ordered = Object.keys(grouped);
        if(Object.keys(grouped).length !== 0 && grouped.constructor === Object || this.announcedEvents && this.announcedEvents.length > 0) {
            if(ordered.includes("Invalid date")){
                ordered.pop("Invalid date");
            }
            ordered.push('Algemeen');
            grouped['Algemeen'] = this.announcedEvents;
        }
        return html`
           
            <div class="page-container flex layout vertical center">
                <div class="banner-container">
                    <slot></slot>
                    <div style="background-image: url('${this.banner}');" class="banner layout vertical center-center">
                        <h1>Alle congressen en cursussen over COPD</a>
                    </div>
                </div>
                <div class="section first shadow">
                    <h1>${localize(this.label)}</h1>
                    
                     ${ grouped && Object.keys(grouped).length > 0 ? html`
                      <div class="layout vertical wrap">
                            ${ordered.map((key) => {
                                const list = grouped[key];
                                return html`
                                <h3>${key}</h3>
                                ${list.map((item) => {
                                    const start_date = item.start_date;
                                    const expired = moment(start_date) > moment();
                                    const url =  "/congres/"+textToSlug(item.title)+"/"+item.id;;
                                    return html`
                                    <div class="item">
                                      <a class="layout horizontal wrap" href="${url}">
                                            <span class="flex">${item.title}</span>
                                            <div class="layout horizontal">
                                                <sw-icon icon="map-marked-alt"></sw-icon>
                                                <span style="margin-right:20px;">${item.location}</span>
                                            </div>
                                            
                                            <div class="layout horizontal">
                                                <sw-icon icon="clock" set="far"></sw-icon>
                                                ${start_date ? html`
                                                    ${expired ? html`
                                                        <sw-date date="${item.start_date}" format="DD MMMM"></sw-date>
                                                    ` : html`
                                                        verlopen
                                                    `}
                                                ` : html`
                                                    
                                                `}
                                            </div>
                                           
                                        </a>
                                    </div>
                                `})}
                            `})}
                      </div>`
                    : ``}
                     
                    ${this.hasMorePages ? html `
                        <div class="layout vertical center-center">
                            <button-contained lowecase gradient strong @click="${()=>store.dispatch(incrementPage(this.requestId, true))}" label="${localize('load_more')}"></button-contained>
                        </div>
                    ` : ``}
                </div>
               
                
               
            </div>
            
            
        `;
    }

}


window.customElements.define("page-events", PageEvents);
